import logo from '@/assets/images/logotipoCoBranding.png'

export default function ApplicationDetailsLogo() {
  return <img className='logo' alt='logo' src={logo} />
}
